export default __webpack_public_path__ + "static/media/84_desktop.909cb41f.jpg";